import { Dispatch } from "redux";
import { setProblems } from "../reducers/problems-reducer";
import { getProblems } from "../requests/problem-requests";

export function getProblemsAction() {
  return (dispatch: Dispatch) => {
    getProblems().then((response) => dispatch(setProblems(response.data.data)));
  };
}
